import Vue from 'vue';
import VueToasted from 'vue-toasted';

Vue.use(VueToasted, { position: process.env.VUE_APP_TOAST_POSITION, duration: process.env.VUE_APP_TOAST_DURATION });